module.exports = __webpack_public_path__ + "c977b05a941ed51e6db4af7246177329.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eldar-vignette-preview-320.webp
// module id = 269
// module chunks = 0